module.exports = __webpack_public_path__ + "static/media/feat-tcr-hero.b883cd7d.jpg";